<template>
    <div>
        <div class="form-group">
            <label>{{ lng.rank}}</label>
            <select v-model="dataRequest.rank"
                    @change="initRequest" >
                <option v-for="rank in flatted"
                        :value="rank.id" v-text="rank.name"
                ></option>
            </select>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import {mapActions, mapGetters} from 'vuex';
    import {flat, getParentId} from '../../plugins/utils';

    export default {
        computed: {
                ...mapGetters([
                    'lng',
                    'selectedVT',
                    'parentRanks',
                    'ranks',
                    'dataRequest'
                ]),
        flatted(){ return flat(this.ranks) }
    },
    methods: {
    ...mapActions([
            'setRanks',
            'prepareRequest',
            'sendRequest',
            'setSelectedVT'
        ]),

                getRanks(){
            this.setSelectedVT({key: 'rank', val: 0});
            axios.post(location.href, {
                id: this.selectedVT.prank,
                action: 'getRanks'
            }).then(response => this.setRanks(response.data.ranks));
        },
        initRequest(){
            var rang = this.dataRequest.rank;
            var el = this.flatted.filter(function(item){
                return item.id===rang;
            }).shift();
            if(el!==undefined && el.children!==undefined){
                var ids = [];
                el.children.map(function(item){
                    if(item.children!==undefined){
                        var subIds = item.children.map(function(subchild){
                            return ids.push(subchild.id);
                        });
                        ids.push(item.id);
                        return subIds;
                    }
                    return ids.push(item.id);
                });
                this.dataRequest.rank = ids;
            }
            this.setSelectedVT({key: 'rank', val: this.dataRequest.rank});
            this.sendRequest();
        }




        // this.setSelectedVT({key: 'rank', val: this.dataRequest.rank});
        // this.sendRequest();
    }

    }





</script>


// WEBPACK FOOTER //
// Rank.vue?f3df66aa